import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import type { ZrmUserInfo } from '@zg-rentals/clickstream';

const analytics = defineAnalytics({ CLICKSTREAM });

export const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo>('CLICKSTREAM');
